import { render, staticRenderFns } from "./ViewBuildingsTable.vue?vue&type=template&id=096be692"
import script from "./ViewBuildingsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBuildingsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports